const routes = () => [
  {
    path: '/',
    component: () => import('../pages/home'),
    exact: true,
    children: [
      {
        path: '/assets/:chainName/:contractAddress/:id',
        component: () => import('../pages/detail'),
        exact: true,
      },
      {
        path: '/sell',
        component: () => import('../pages/sell'),
        exact: true,
      },
      {
        path: '/test',
        component: () => import('../pages/test'),
        exact: true,
      },
    ],
  },
  {
    path: '/mystery',
    component: () => import('../pages/mystery'),
    exact: true,
    children: [
      {
        path: '/mystery/:chainName/:name',
        component: () => import('../pages/mysteryDetail'),
        exact: true,
      },
    ],
  },

  {
    path: '/explore',
    component: () => import('../pages/market'),
    exact: true,
    children: [
      {
        path: '/marketplace',
        component: () => import('../pages/market'),
        exact: true,
        hideFooter: true,
      },
      {
        path: '/collections',
        component: () => import('../pages/collections'),
        exact: true,
        children: [
          {
            path: '/collection/:chainName/:collectName',
            component: () => import('../pages/collections/details'),
            exact: true,
            hideFooter: true,
          },
        ],
      },
    ],
  },

  {
    path: '/create',
    component: () => import('../pages/create'),
    hideFooter: true,
  },
  {
    path: '/createCollection',
    component: () => import('../pages/createCollection'),
    exact: true,
  },
  {
    path: '/search',
    component: () => import('../pages/searchResult'),
    exact: true,
    hideFooter: true,
  },
  {
    path: '/account/:userName',
    component: () => import('../pages/myNfts'),
    exact: true,
    hideFooter: true,
  },
  {
    path: '/myCollections',
    component: () => import('../pages/myCollections'),
    exact: true,
    hideFooter: true,
  },
  {
    path: '/settings',
    component: () => import('../pages/settings'),
    exact: true,
    hideFooter: true,
  },
  {
    path: '/whitePaper',
    component: () => import('../pages/whitePaper'),
    exact: true,
  },
  {
    path: '*',
    component: () => import('../pages/404'),
    exact: true,
  },
]
export default routes
